module.exports = __webpack_public_path__ + "img/hair_back_female_straight_medium.90e7bca5.png";